import { render } from "./LoadedOrPlaceholder.vue?vue&type=template&id=c94d36d2&ts=true"
import script from "./LoadedOrPlaceholder?vue&type=script&lang=ts&external"
export * from "./LoadedOrPlaceholder?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__